import moment from "moment";
import {
  FollowUp,
  Reschedule,
  SlotToken,
  UpdateBookingStatus,
  addBookingData,
} from "../utils/types";
import { baseURL } from "../utils/constants";
import axiosInstance from "../utils/axiosUtil";

//Get bookings by hospital id
export const getBookingListByHospitalId = async (id: string | undefined) => {
  const date = moment().format("YYYY-MM-DD");
  try {
    const res = await axiosInstance.get(`${baseURL}/booking/hospital/${id}`, {
      params: { date: date },
    });
    return res;
  } catch (error: any) {
    if (error.response || error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Get Booking List by Availability Id
export const getBookingListByAvailabilityId = async (
  availability_id: string | undefined,
  date: string
) => {
  try {
    const res = await axiosInstance.get(
      `${baseURL}/booking/doctor/availabilities/${availability_id}?date=${date}`,
    );
    return res;
  } catch (error: any) {
    if (error.response) {
      console.error(error.response);
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Get Slots
export const getSlots = async (data: SlotToken) => {
  try {
    const res = await axiosInstance.post(
      `${baseURL}/hospital/availability/slots`,
      data,
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

//Get Tokens
export const getTokens = async (data: SlotToken) => {
  try {
    const res = await axiosInstance.post(
      `${baseURL}/hospital/availability/tokens`,
      data,
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

//Add new booking
export const addBooking = async (req: addBookingData) => {
  console.log(req);
  try {
    const res = await axiosInstance.post(`${baseURL}/booking`, req);
    return res;
  } catch (error: any) {
    if (error.response) {
      console.error(error.response);
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Reschedule Booking
export const rescheduleBooking = async (
  booking_id: string,
  req: Reschedule
) => {
  try {
    const res = await axiosInstance.patch(
      `${baseURL}/booking/reschedule/${booking_id}`,
      req,
    );
    return res;
  } catch (error: any) {
    if (error.response) {
      console.error(error.response);
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Follow-Up
export const addFollowUp = async (req: FollowUp) => {
  try {
    const res = await axiosInstance.post(`${baseURL}/booking/followup`, req);
    return res;
  } catch (error: any) {
    if (error.response) {
      console.error(error.response);
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Update booking status
export const updateBookingStatus = async ({
  bookingId,
  status,
}: UpdateBookingStatus) => {
  try {
    const res = await axiosInstance.put(
      `${baseURL}/booking/${bookingId}/status`,
      {
        status: status,
      }
    );
    return res;
  } catch (error: any) {
    if (error.response) {
      console.error(error.response);
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Get OnGoing ID
export const getOnGoing = async (
  id: string,
  session: string,
  date: string | undefined
) => {
  try {
    const res = await axiosInstance.get(`${baseURL}/queue/${id}/${session}`, {
      params: { date: date },
    });
    return res;
  } catch (error: any) {
    if (error.response || error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Check Availability
export const checkAvailability = async (
  availability_id: string,
  adjustment_date: string
) => {
  try {
    const res = await axiosInstance.post(
      `${baseURL}/hospital/check-availability-status`,
      {
        availability_id: availability_id,
        adjustment_date: adjustment_date,
      }
    );
    return res;
  } catch (error: any) {
    if (error.response) {
      console.error(error.response);
      return error.response;
    } else {
      console.error(error);
    }
  }
};
